import React, { useState, useEffect } from "react";
import DataSelectDay from "./DataSumaryReport/dataSelectDay";
import DataSelectType from "./DataSumaryReport/dataSelectType";
import { Button, Form, Row, Col, Table, DatePicker, Select, Card } from "antd";
//import dayjs from "dayjs";
import dataColumns from "./DataSumaryReport/DataColumns";
import dataColumnMain from "./DataSumaryReport/DataColumnMain";
import postPreAll from "./DataSumaryReport/PostPreAll";
import sumDataAll from "./DataSumaryReport/sumDataAll";
import SearchPDF from "./DataSumaryReport/SearchPDF";

function SumaryReport() {
  const [inputDate, setInputDate] = useState(false);
  const [dataDay, setDataDay] = useState([]);
  const [dataType, setDataType] = useState([]); //ประเภทสัญญา
  const [loading, setLoading] = useState(false); //โหลดข้อมูล
  const [tableV120, setTableV120] = useState([]); //ตาราง
  const [tableV180, setTableV180] = useState([]);
  const [tableV270, setTableV270] = useState([]);
  const [tableR120, setTableR120] = useState([]);
  const [tableR180, setTableR180] = useState([]);
  const [tableR270, setTableR270] = useState([]);
  const [sumCountV120, setSumCountV120] = useState([]); //ตาราง นับ
  const [sumCountV180, setSumCountV180] = useState([]);
  const [sumCountV270, setSumCountV270] = useState([]);
  const [sumCountR120, setSumCountR120] = useState([]);
  const [sumCountR180, setSumCountR180] = useState([]);
  const [sumCountR270, setSumCountR270] = useState([]);
  //input วันเดือนปี
  const onChangeDate = (dateSelect2) => {};
  //ระยะเวลาขาดการติดต่อ จาก input
  const handleChangeDay = (value) => {
    //console.log(`selected ${value}`);
    const dDay = value;
    setDataDay(dDay);
  };
  //ประเภทสัญญา จาก input
  const handleChangeType = (value) => {
    //console.log(`selected ${value}`);
    const dType = value;
    setDataType(dType);
  };
  //form-Error
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  //form-Success
  const onFinish = async (values) => {
    console.log("values", values);
    //วันเดือนปี  จาก input
    //const startDate = moment(values.SearchDate.$d).format("YYYY-MM-DD");
    const startDate = values.SearchDate?.format("YYYY-MM-DD");
    //console.log(startDate,'startDate')
    setInputDate({ startDate });
  };

  //ตารางรอง
  const expandedRowRender = () => (
    <Table
      columns={dataColumns}
      dataSource={
        dataDay === "120" && dataType === "vsfhp"
          ? [...(tableV120 || [])]
          : dataDay === "180" && dataType === "vsfhp"
          ? [...(tableV180 || [])]
          : dataDay === "270" && dataType === "vsfhp"
          ? [...(tableV270 || [])]
          : dataDay === "120" && dataType === "rpsl"
          ? [...(tableR120 || [])]
          : dataDay === "180" && dataType === "rpsl"
          ? [...(tableR180 || [])]
          : dataDay === "270" && dataType === "rpsl"
          ? [...(tableR270 || [])]
          : []
      }
      //pagination={false}
    />
  );
  //ส่งไป PDF
  const sumCountGroup = {
    sumCountV120,
    sumCountV180,
    sumCountV270,
    sumCountR120,
    sumCountR180,
    sumCountR270,
  };
  const tableGroup = {
    tableV120,
    tableV180,
    tableV270,
    tableR120,
    tableR180,
    tableR270,
  };

  //ดึงข้อมูลค้นหา
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // เริ่มโหลด
      try {
        //console.log("inputDate", inputDate.startDate);
        const inDate = inputDate.startDate;
        const dataV = "vsfhp";
        const dataR = "rpsl";
        const day120 = "120";
        const day180 = "180";
        const day270 = "270";

        const V120 = await postPreAll({
          inDate,
          textDay: day120,
          textType: dataV,
        });
        //console.log("V120", V120);
        setTableV120(V120);
        const V180 = await postPreAll({
          inDate,
          textDay: day180,
          textType: dataV,
        });
        //console.log("V180", V180);
        setTableV180(V180);
        const V270 = await postPreAll({
          inDate,
          textDay: day270,
          textType: dataV,
        });
        //console.log("V270", V270);
        setTableV270(V270);

        const R120 = await postPreAll({
          inDate,
          textDay: day120,
          textType: dataR,
        });
        //console.log("R120", R120);
        setTableR120(R120);
        const R180 = await postPreAll({
          inDate,
          textDay: day180,
          textType: dataR,
        });
        //console.log("R180", R180);
        setTableR180(R180);
        const R270 = await postPreAll({
          inDate,
          textDay: day270,
          textType: dataR,
        });
        //console.log("R270", R270);
        setTableR270(R270);

        //หาผลรวม
        const sumV120 = sumDataAll({
          sumDataDay: V120,
          textDay: day120,
          textType: dataV,
        });
        setSumCountV120(sumV120);
        const sumV180 = sumDataAll({
          sumDataDay: V180,
          textDay: day180,
          textType: dataV,
        });
        setSumCountV180(sumV180);
        const sumV270 = sumDataAll({
          sumDataDay: V270,
          textDay: day270,
          textType: dataV,
        });
        setSumCountV270(sumV270);

        const sumR120 = sumDataAll({
          sumDataDay: R120,
          textDay: day120,
          textType: dataR,
        });
        setSumCountR120(sumR120);
        const sumR180 = sumDataAll({
          sumDataDay: R180,
          textDay: day180,
          textType: dataR,
        });
        setSumCountR180(sumR180);
        const sumR270 = sumDataAll({
          sumDataDay: R270,
          textDay: day270,
          textType: dataR,
        });
        setSumCountR270(sumR270);
      } catch (error) {
        console.error("โหลดข้อมูลไม่สำเร็จ", error);
      } finally {
        setLoading(false); // จบการโหลด
      }
    };
    if (inputDate) {
      fetchData();
    }
  }, [inputDate]);
  return (
    <>
      <div style={{ padding: "10px" }}>
        <h2 style={{ textAlign: "center", color: "black" }}>
          รายงานสืบทรัพย์ก่อนฟ้อง ตามสถานะยังไม่สืบ หรือยังไม่บอกเลิก
        </h2>
        <Form
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          // initialValues={{
          //   SelectDataType: "AY", // Set the default value here
          // }}
        >
          {" "}
          <Card style={{ width: "100%", height: "120px", margin: "10px" }}>
            <Row>
              <Col span={4}>
                <Form.Item
                  label="เลือกวันเดือนปี"
                  name="SearchDate"
                  rules={[
                    {
                      required: true,
                      message: "เลือกวันเดือนปี!",
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={["เลือกวันเดือนปี"]}
                    style={{ margin: "0 4px 10px" }}
                    format="DD-MM-YYYY"
                    onChange={(date, dateString) => {
                      onChangeDate(date, dateString);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="เลือกประเภทสัญญา"
                  name="SelectDataType"
                  rules={[
                    {
                      required: true,
                      message: "เลือกประเภทสัญญา!",
                    },
                  ]}
                  style={{ margin: "0 4px 120px" }}
                >
                  <Select
                    style={{ width: 240 }}
                    onChange={handleChangeType}
                    options={DataSelectType}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="เลือกระยะเวลาขาดการติดต่อ"
                  name="SelectDataDay"
                  rules={[
                    {
                      required: true,
                      message: "เลือกระยะเวลาขาดการติดต่อ!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: 320 }}
                    onChange={handleChangeDay}
                    options={DataSelectDay}
                  />
                </Form.Item>
              </Col>
              <Col span={2}>
                <Form.Item label=" ">
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ margin: "0 2px 4px" }}
                  >
                    ค้นหา
                  </Button>
                </Form.Item>
              </Col>
              <Col span={2}>
                <Form.Item label=" ">
                  <SearchPDF
                    dataDay={dataDay}
                    dataType={dataType}
                    tableGroup={tableGroup}
                    sumCountGroup={sumCountGroup}
                  ></SearchPDF>
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Form>

        <Table
          columns={dataColumnMain}
          //expandable={{ expandedRowRender, defaultExpandedRowKeys: ['0'] }}
          rowKey={(record) => `${record.countType}_${record.countDay}`}
          expandable={{
            expandedRowRender,
          }}
          dataSource={
            dataDay === "120" && dataType === "vsfhp"
              ? [...(sumCountV120 || [])]
              : dataDay === "180" && dataType === "vsfhp"
              ? [...(sumCountV180 || [])]
              : dataDay === "270" && dataType === "vsfhp"
              ? [...(sumCountV270 || [])]
              : dataDay === "120" && dataType === "rpsl"
              ? [...(sumCountR120 || [])]
              : dataDay === "180" && dataType === "rpsl"
              ? [...(sumCountR180 || [])]
              : dataDay === "270" && dataType === "rpsl"
              ? [...(sumCountR270 || [])]
              : []
          }
          loading={loading}
        />
      </div>
    </>
  );
}
export default SumaryReport;
